import {createSlice} from "@reduxjs/toolkit";

const initialLinksState = {
  listLoading: false,
  actionsLoading: false,
  lastError: null,
  totalCount: 0,
  categories: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const CategoriesSlice = createSlice({
  name: "categories",
  initialState: initialLinksState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findCategoryList
    CategoriesFetched: (state, action) => {
      const { categories } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.categories = categories;
    },
    // getCategoryById
    CategoriesUpdated: (state, action) => {
      const { categories } = action.payload;
      state.actionsLoading = false;
      state.categories = categories;
      state.error = null;
    },
  }
});
